<template>
  <div class="app-right">
    <div class="right-sticky">
      <!--      <div class="right_item">-->
      <!--        <div class="right_item_title">-->
      <!--          网站说明-->
      <!--        </div>-->
      <!--        <div class="right_item_content">-->
      <!--          本站为个人博客，博客所发布的一切软件的文章仅限用于学习和研究目的；不得将上述内容用于商业或者非法用途，否则，一切后果请用户自负。本站信息来自网络，版权争议与本站无关，您必须在下载后的24个小时之内，从您的电脑中彻底删除上述内容。访问和下载本站内容，说明您已同意上述条款。-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="right_item" v-if="tocFlag">
        <div class="right_item_title">
          文章目录
        </div>
        <div class="right_item_content">
          <div class="sidebar">
            <ul>
              <li v-for="item in toc" :key="item.id">
                <div class="item-li text-overflow">
                  <a :href="`#${item.id}`" @click.prevent="scrollTo(item.id)">{{ item.text }}</a>
                </div>
                <ul v-if="item.children.length">
                  <li v-for="child in item.children" :key="child.id">
                    <div class="item-li text-overflow">
                      <a :href="`#${child.id}`" @click.prevent="scrollTo(child.id)">{{ child.text }}</a>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="right_item">
        <div class="right_item_title">
          公告
        </div>
        <div class="right_item_content">
          <div class="notice-item" v-for="item in noticeList" :key="item.articleId">
            <i class="el-icon-caret-right"></i>
            <a :href="'/detail/'+item.articleId" target="_blank">{{ item.title }}</a>
          </div>
        </div>
      </div>
      <div class="right_item">
        <div class="right_item_title">
          最新发布
        </div>
        <div class="right_item_content">
          <data-list-small :loading="hotLoading" :data-list="dataList"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as articleApi from "@/api/article"
import DataListSmall from "@/views/article/components/data-list-small.vue";
import {mapState} from "vuex";

export default {
  components: {DataListSmall},
  computed: {
    ...mapState(["toc", "tocFlag"])
  },
  data() {
    return {
      hotLoading: true,
      noticeLoading: true,
      dataList: [],
      noticeList: [],
    }
  },
  mounted() {
    articleApi.listArticle(
        {
          pageNum: 1,
          pageSize: 5,
          orderBy: "updateTime",
          sort: "desc",
          first: "document",
          second: "system",
          third: "notice",
        }
    ).then(res => {
      this.noticeList = res.data.list;
    }).finally(() => {
      this.noticeLoading = false;
    })

    articleApi.listArticle(
        {
          pageNum: 1,
          pageSize: 10,
          orderBy: "createTime",
          sort: "desc",
          first: "game",
        }
    ).then(res => {
      this.dataList = res.data.list;
    }).finally(() => {
      this.hotLoading = false;
    })
  },
  methods: {
    scrollTo(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center', // 或者 'end' 根据需要
        });
      }
    },

  }
}
</script>

<style lang="scss">
.app-right {
  .right-sticky {
    position: sticky;
    top: 60px;

    .right_item {
      padding: 20px;
      background-color: --color(--p-white);
      border: 1px solid --color(--p-border-color);
      box-shadow: 0 8px 16px -4px rgba(44, 45, 48, 0.047);
      margin-bottom: 20px;
      border-radius: $base-border-radius;
      overflow: hidden;

      .right_item_title {
        font-weight: 500;
        font-size: 16px;
        color: --color(--p-text-34);
        margin-bottom: 10px;
      }

      .right_item_content {
        font-size: 13px;
        color: --color(--p-text-34);

        .notice-item {
          padding: 3px 0;

          a {
            color: --color(--p-text-34);
            transition: 0.2s;
          }

          a:hover {
            color: $base-color-primary;
          }
        }

        .sidebar {
          ul {
            list-style-type: none;
            padding: 0;
            margin: 0;

            li {
              padding-left: 20px;

              .item-li {
                margin: 8px 0;

                a {
                  display: block;
                  color: --color(--p-text-34);
                  font-size: 14px;
                }

                a:hover {
                  color: $base-color-primary;
                }
              }

            }
          }
        }
      }
    }
  }
}
</style>
